import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PlanMap } from "@/components/PlanMap";
import { AdCard, activeNow } from "@/components/AdCard";
import { StartPicker } from "@/components/StartPicker";
import { Chip } from "@/components/Chip";

export default function Deals() {
  const { user } = useAuth();
  const [where, setWhere] = useState(user?.profile?.home || null);
  const [ads, setAds] = useState(null);
  const [onlyNow, setOnlyNow] = useState(false);
  useEffect(() => {
    if (where) api.get("/deals", { params: { lat: where.lat, lon: where.lon, km: 8 } }).then((r) => setAds(r.data));
  }, [where]);
  const shown = (ads || []).filter((a) => !onlyNow || activeNow(a.time_slots));

  return (
    <div className="max-w-6xl mx-auto px-5 py-10 lg:py-14 space-y-8" data-testid="deals-page">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#23603F]">Sponsored · approved local businesses</p>
        <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold tracking-tight">Local deals</h1>
        <p className="mt-2 text-stone-600 max-w-2xl">Offers from nearby businesses, each reviewed by Outbound. Deals only run during the times shown.</p>
      </div>
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-6">
        <div className="space-y-4">
          <StartPicker value={where} onChange={setWhere} home={user?.profile?.home} testPrefix="deals-where" />
          <div className="flex gap-2">
            <Chip tone="forest" testId="deals-filter-all" active={!onlyNow} onClick={() => setOnlyNow(false)}>All deals</Chip>
            <Chip tone="forest" testId="deals-filter-now" active={onlyNow} onClick={() => setOnlyNow(true)}>Active now</Chip>
          </div>
          {ads && shown.length === 0 && <p className="text-sm text-stone-500" data-testid="deals-empty">No deals {onlyNow ? "running right now" : "within 8 km"} yet.</p>}
          <div className="space-y-3">{shown.map((a, i) => <AdCard key={a.id} ad={a} testId={`deal-card-${i}`} />)}</div>
        </div>
        <div className="h-[420px] lg:h-[600px] lg:sticky lg:top-24 rounded-3xl overflow-hidden border border-stone-200 relative z-0" data-testid="deals-map">
          <PlanMap start={where} dots={shown.map((a) => ({ pid: a.id, name: `${a.business_name}: ${a.offer}`, cat: a.category, lat: a.location.lat, lon: a.location.lon }))} />
        </div>
      </div>
    </div>
  );
}
